import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { nl, enUS } from 'date-fns/locale';

/**
 * Numbers and dates in the dashboard language. `intlLocale` is for Intl / toLocale*,
 * `dateFnsLocale` for date-fns. en-GB rather than en-US: day before month, 24-hour clock.
 */
export function useLocaleFormat() {
  const { locale } = useI18n();
  const intlLocale = computed(() => (locale.value === 'nl' ? 'nl-NL' : 'en-GB'));
  const dateFnsLocale = computed(() => (locale.value === 'nl' ? nl : enUS));

  const num = (n: number) => n.toLocaleString(intlLocale.value);
  // toLocaleString, not toLocaleDateString: the latter throws on timeStyle. Without time
  // options both print the same.
  const date = (iso: string | Date | null | undefined, opts: Intl.DateTimeFormatOptions = { dateStyle: 'medium' }) =>
    iso ? new Date(iso).toLocaleString(intlLocale.value, opts) : '';
  const dateTime = (iso: string | Date | null | undefined) => date(iso, { dateStyle: 'medium', timeStyle: 'short' });

  return { intlLocale, dateFnsLocale, num, date, dateTime };
}
